

































































import ItemCol from './ItemCol.vue';
import BlockHeader from './BlockHeader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'workExperience',
  components: {
    ItemCol,
    BlockHeader
  }
})
export default class extends Vue {
  @Prop() public studentWorkDtos!: any;
}
